import React from 'react';

const SelectObjectItem = (props) => {
    let classValue = "list-group-item";

    if (props.selected === props.item) {
        classValue += " active"
    }

    const onClick = ()=> {
        props.onClick(props.item);
    }

    return <button onClick={onClick} className={classValue} title={props.description}>{props.tags ? props.tags.map(tag=> <span className={"tag"} key={tag}>{tag}</span>): ""}{props.name}</button>
}

export default SelectObjectItem
